/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
 * tree and available online at
 *
 * https://www.atmire.com/software-license/
 */
import { Component, Input } from '@angular/core';
import { ThumbnailComponent as BaseComponent } from '../../../../app/thumbnail/thumbnail.component';

@Component({
  selector: 'ds-thumbnail',
  // styleUrls: ['./thumbnail.component.scss'],
  styleUrls: ['../../../../app/thumbnail/thumbnail.component.scss'],
  // templateUrl: './thumbnail.component.html',
  templateUrl: '../../../../app/thumbnail/thumbnail.component.html',
})
export class ThumbnailComponent extends BaseComponent {
  @Input() defaultImage = 'assets/client/images/fsc-thumbnail.png';

  showFallback() {
    if (this.src$.getValue() !== this.defaultImage) {
      this.setSrc(this.defaultImage);
    } else {
      // todo: disable HTML fallback, as the fallback image would sometimes trip the error handler (even though it renders properly)
      //       haven't seen this in other projects before, so presumably it's also due to the consentmanager somehow
      // this.setSrc(null);
    }
  }
}
